import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "employee-onboarding-materials"
    }}>{`Employee Onboarding Materials`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Onboarding new customers into a company or new role takes time and resources. Human Resources often needs to share items like welcome packets, employee handbooks, and resource guides. Customizing onboarding documents for specific employees, roles, seniority levels, and regions improves the employee experience but can be very time consuming for HR teams when done manually.`}</p>
    <p>{`Adobe Acrobat Services allows organizations to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard templates for employee onboarding documents`}</li>
      <li parentName="ul">{`Merge specific employee data automatically (start date, onboarding task deadlines, etc.)`}</li>
      <li parentName="ul">{`Include or exclude document sections automatically based on employee data`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`An HR team in a growing company is struggling to generate onboarding materials for its many new hires. The team currently assembles and customizes welcome packets in Microsoft Word, while manually referencing data in their HR system. The new hires have various responsibilities and seniority levels. Automating templates would make welcome packet creation quick and smooth, and would give HR time back.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design onboarding templates using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the templates based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the appropriate templates, creating a final legal letter in PDF`}</li>
      <li parentName="ol">{`Send PDFs to the employee`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      